import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ViewComponent } from '../../../core/view/view.component';
import { ZonesService } from '../zones.service';

@Component({
  selector: 'app-zones-detail',
  templateUrl: './zones-detail.component.html',
  styleUrls: ['./zones-detail.component.scss']
})
export class ZonesDetailComponent implements OnInit {

  @ViewChild("view") public view: ViewComponent;
  public zone: any = {};
  constructor(
    private zonesService: ZonesService,

    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private coreDialogService: CoreDialogService,
  ) { }

  ngOnInit(): void {
    this.loadZones(this.config.data.id);
  }

  loadZones(id) {
    if (id) {
      this.zonesService.get(id).subscribe(
        data => {
          this.zone = data;
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    }
  }

  save(event: any) {
    if (!event.valid) {
      this.messageService.add({ closable: false, severity: "error", detail: "Datos incompletos. Por favor, revisa el formulario." });
      return;
    }
    if (typeof this.zone.id === "undefined") {
      this.zonesService.add(this.zone).subscribe(
        data => {
          this.zone = data;
          this.loadZones(this.zone.id);
          this.messageService.add({ closable: false, severity: 'success', summary: "Zona añadida correctamente." });
          this.dynamicDialogRef.close();
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
    } else {
      this.zonesService.save(this.zone.id, this.zone).subscribe(
        data => {
          this.zonesService.add({ closable: false, severity: "success", detail: "Zona guardada correctamente" });
          this.dynamicDialogRef.close();
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
    }
  }
  cancel() {
    this.dynamicDialogRef.close();
  }
  delete() {
    this.coreDialogService.confirm({
      message: "¿Quieres borrar la zona " + this.zone.name + "?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.zonesService.delete(this.zone.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: "Borrada correctamente" });
            this.dynamicDialogRef.close();
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        )
      },
      reject: () => {

      }
    })
  }
  isDuplied(zone, event) {
    if (!event.valid) {
      this.messageService.add({ closable: false, severity: "error", detail: "Datos incompletos. Por favor, revisa el formulario." });
      return;
    }
    this.zonesService.isDuplied(zone).subscribe(
      data => {
        if (data == true) {
          this.coreDialogService.notify({
            message: "Ya existe una zona con estos datos proporcionados.",
            header: 'Error',
            icon: 'far exclamation-circle',
            color: 'var(--orange-500)',
            accept: () => { }
          });
        } else {
          this.save(event);
        }
      }
    );
  }
  onEvent(event) {
    if (event.component == "zone.edit.general") {
      if (event.event == "action" && event.action.name == "delete") this.delete();
      if (event.event == "action" && event.action.name == "cancel") this.cancel();
      if (event.event == "action" && event.action.name == "save") this.isDuplied(this.zone, event);
    }
    if (event.component == "view" && event.event == "entity-loaded") {
      this.config.header = typeof (this.zone.id) !== "undefined" ? "Detalles de la " + this.view.getEntityBaseName() : "Nueva " + this.view.getEntityBaseName();
    }
  }
}
